import Amplify, { API, graphqlOperation } from "aws-amplify";
import { getDocumentEstimateData, applyWorkOrderTemplate, getDocumentWorkOrderData, createDocWithTemplate} from '../../graphql/queries';
import { onProgressUpdate }  from '../../graphql/subscriptions';
import {consoleLog} from '../commonFunctions.js';
import config from "../../aws-exports";
Amplify.configure(config);

export const isEmpty = (value) => { 
  if (value === '' || value === null || typeof value === 'undefined') {
    return true;
  }
  return false;
}

export const parseNumber = (value) => { 
  if (isNaN(Number.parseFloat(value))) {
    return 0;
  }
  return Number.parseFloat(value);
}

export const formatPhoneNumber = (str) => {
    //Filter only numbers from the input
    let cleaned = ('' + str).replace(/\D/g, '');
    
    //Check if the input is of correct length
    let match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
  
    if (match) {
      return '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4]
    };
    
    //Check if the input is of correct length
    let match2 = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  
    if (match2) {
      return '(' + match2[1] + ') ' + match2[2] + '-' + match2[3]
    };

    return str
};

export const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,      
  maximumFractionDigits: 2,
});

export const adjusted_quantity_calculation = (props) => {
  let ratio_fromx = props?.ratio_from ? props.ratio_from : 1;
  let ratio_tox = props?.ratio_to ? props.ratio_to : 1;
  let quantityx = 1 * (props?.quantity || 0);
  let wastex = 1 * (props?.waste || 0);
  let convert_roundx = 1 * (props?.convert_round || 0);
  let quant = quantityx * ratio_tox / ratio_fromx;
  let adjusted_quantityx = ((100 + wastex) * quant) / 100;
  if (convert_roundx) {
    adjusted_quantityx = Math.ceil(adjusted_quantityx);
    adjusted_quantityx = adjusted_quantityx.toFixed(2);
    adjusted_quantityx = Number.parseFloat(adjusted_quantityx);
  } else {
    adjusted_quantityx = Math.round(adjusted_quantityx * 100) / 100;
    adjusted_quantityx = adjusted_quantityx.toFixed(2);
    adjusted_quantityx = Number.parseFloat(adjusted_quantityx);
  }
  return adjusted_quantityx;
}

export const calculateAdjQuantity = (line_item) => {
  let calc_qty = adjusted_quantity_calculation(line_item);
  if (
    line_item?.adjusted_quantity !== undefined &&
    line_item?.adjusted_quantity !== null &&
    line_item?.adjusted_quantity !== '' &&
    !isNaN(line_item.adjusted_quantity) &&
    +line_item.adjusted_quantity !== 0
  ) {
    let stored_qty = Number.parseFloat(line_item.adjusted_quantity);
    if (Math.abs(stored_qty - calc_qty) <= 0.05) {
      return Number.parseFloat(calc_qty).toFixed(2);
    }
    return stored_qty.toFixed(2);
  }
  return Number.parseFloat(calc_qty).toFixed(2);
}

export const calculateNetCost = (line_item) => {
  let net_cost;
  let adjusted_quantity = calculateAdjQuantity(line_item);
  let qty = (adjusted_quantity == 0 || adjusted_quantity === "0.00") ? line_item.quantity : adjusted_quantity;
  net_cost = line_item.cost * qty;
  console.log('calculateNetCost', net_cost);
  console.log('calculateNetCost typeof', typeof net_cost);
  net_cost = parseFloat(net_cost);
  return net_cost.toFixed(2);
}

export const calculateNetCostx = (line_item) => {
  let net_cost = 0;
  let adjusted_quantity = calculateAdjQuantity(line_item);
  let qty = (adjusted_quantity == 0 || adjusted_quantity === "0.00") ? line_item.quantity : adjusted_quantity;
  net_cost = line_item.cost * qty;
  net_cost = Number.parseFloat(Number.parseFloat(net_cost).toFixed(2));
  return net_cost;
}

export const calculateDataWO = (data) => {

  let subTotal = 0;
  let matCost = 0;
  let oNpCost = 0;
  let totalQuantity = 0;

  if(data && data.structures) {
    for (const structure of data.structures) {
      for (const category of structure.categories) {
        for (const lineItem of category.line_items) {
          let qty = calculateAdjQuantity(lineItem);
          let realQty = (qty == 0 || qty === "0.00") ? lineItem.quantity : qty;
          let netCost = Number.parseFloat(Number.parseFloat(lineItem.cost * realQty).toFixed(2));
          if(lineItem.unit != ''){
            subTotal = subTotal + 1 * netCost;
          
            totalQuantity = totalQuantity + 1 * realQty;
            matCost = matCost + 1 * filterNumber(lineItem.material_cost) * (1 * realQty);

            if (parseInt(lineItem.apply_op) === 1) {
              oNpCost = oNpCost + 1 * netCost;
            }
          }
        }
      }
    }
  }

  subTotal = Number.parseFloat(subTotal).toFixed(2);
  matCost = Number.parseFloat(matCost);
  oNpCost = Number.parseFloat(oNpCost);

  let calculatedData = getMarkupsAndTaxesCalculation(data, subTotal, matCost, oNpCost);

  return {...calculatedData, totalQuantity: totalQuantity}
}


export const calculateData = (data) => {

  let subTotal = 0;
  let matCost = 0;
  let oNpCost = 0;
  let totalQuantity = 0;

  if(data && data.structures) {
    for (const structure of data.structures) {
      for (const category of structure.categories) {
        if(category?.line_items == undefined){
          category.line_items = [];
        }
        for (const lineItem of category.line_items) {
          // let netCost = filterNumber(lineItem.net_cost);
          let netCost = calculateNetCostx(lineItem);
          // console.log('calculateData netCost', netCost);
          // let qty = filterNumber(lineItem.adjusted_quantity);
          let qty = calculateAdjQuantity(lineItem);
          // console.log('calculateData qty', qty);
          if(lineItem.unit != ''){
            subTotal = subTotal + 1 * netCost;
          
            totalQuantity = totalQuantity + 1 * qty;
            matCost = matCost + (1 * filterNumber(lineItem.material_cost) * qty);

            if (parseInt(lineItem.apply_op) === 1) {
              oNpCost = oNpCost + 1 * netCost;
            }
          }
        }
      }
    }
  }

  subTotal = Number.parseFloat(subTotal).toFixed(2);
  matCost = Number.parseFloat(matCost);
  oNpCost = Number.parseFloat(oNpCost);

  let calculatedData = getMarkupsAndTaxesCalculation(data, subTotal, matCost, oNpCost);

  return {...calculatedData, totalQuantity: totalQuantity}
}

const getMarkupsAndTaxesCalculation = (data, subTotal, matCostTotal, oNpCostTotal) => {
  
  let markups = data.markups;

  if(typeof markups === 'string') {
    markups = JSON.parse(data.markups);
  }else {
    markups = data.markups;
  }

  let taxesArray = [];
  let markupArray = [];
  let totalMarkup = 0;
  let totalOPMarkup = 0;
  let totalMatCost = 0;
  let totalCostPercentage = 0;
  let fixedMarkup = 0;
  let nonFixedMarkup = 0;
  let fixedTax = 0;
  if (markups && typeof markups === 'object' && Object.keys(markups).length > 0) {

    Object.entries(markups).forEach(([key, markup]) => {
      if (markup.type === "markup" || markup.type === "op") {
        console.log("getMarkupsAndTaxesCalculation ", markup);
        //calculations for total markup
        if (markup.type === "markup") {
          let total = 0;
          const markupValue = filterNumber(markup.value);
            if(markup.value_type == 'fixed'){
              total = markupValue;
              fixedMarkup = fixedMarkup + markupValue;
            } else {
              totalMarkup = totalMarkup + markupValue;
              total = subTotal * (markupValue / 100);
            }
            markup.total = total.toFixed(2);
        }

        //calculations for total OP markup
        if (markup.type === "op") {
          let totalOp = 0;
          const markupValue = filterNumber(markup.value);
          if(markup.value_type == 'fixed'){
            totalOp = markupValue;
            nonFixedMarkup = nonFixedMarkup + markupValue;
          } else {
            totalOPMarkup = totalOPMarkup + markupValue;
            totalOp = oNpCostTotal * (markupValue / 100);
          }
          markup.total = totalOp.toFixed(2);
        }

        markupArray.push(markup);
        
      }else if (markup.type === "tax") {

        //calculations for material cost
        if (markup.for === "material") {
          let matCost = 0;
          const taxValue = filterNumber(markup.value);
          if(markup.value_type == "fixed") {
            fixedTax = fixedTax + taxValue;
            matCost = taxValue;
          } else {
            totalMatCost = totalMatCost + taxValue; // ading the percentages to calculate material cost
            matCost = matCostTotal * (taxValue / 100);
          }
          markup.total = matCost.toFixed(2);
        }

        //calculations for total cost
        if (markup.for === "all") {
          const taxValue = filterNumber(markup.value);
          const taxPercent = filterNumber(markup.percent);
          if(markup.value_type == "fixed") {
            markup.total = taxValue.toFixed(2);
            fixedTax = fixedTax + taxValue;
          } else {
            let percentageOne = subTotal * (taxPercent / 100);
            let percentageTwo = percentageOne * (taxValue / 100);
            let percentage = percentageTwo.toFixed(2);
            totalCostPercentage += parseFloat(percentage);
            markup.total = percentage;
          }
        }
        taxesArray.push(markup);
      }
    });
  }
  let subTotalPercentage = subTotal * (totalMarkup / 100);
  subTotalPercentage = subTotalPercentage + fixedMarkup;
  subTotalPercentage = Number.parseFloat(subTotalPercentage).toFixed(2);
  
  let oNpCostTotalPercentage = oNpCostTotal * (totalOPMarkup / 100);
  oNpCostTotalPercentage = oNpCostTotalPercentage + nonFixedMarkup;
  oNpCostTotalPercentage = Number.parseFloat(oNpCostTotalPercentage).toFixed(2);
  
  let totalMatCostPercentage = matCostTotal * (totalMatCost / 100);
  totalMatCostPercentage = totalMatCostPercentage + fixedTax;

  totalMatCostPercentage = Number.parseFloat(totalMatCostPercentage).toFixed(2);
  
  let total =
        Number.parseFloat(subTotal) +
        Number.parseFloat(subTotalPercentage) +
        Number.parseFloat(oNpCostTotalPercentage) +
        Number.parseFloat(totalMatCostPercentage) +
        Number.parseFloat(totalCostPercentage);

  return {total: total.toFixed(2), subTotal: subTotal, taxes: taxesArray, markups: markupArray, totalMarkup: subTotalPercentage, totalOpMarkup: oNpCostTotalPercentage, totalMaterialCost: totalMatCostPercentage, totalCost: Number.parseFloat(totalCostPercentage).toFixed(2)}
}

const filterNumber = (number) => {

  const parsedNumber = Number.parseFloat(number);
  if(!Number.isFinite(parsedNumber)) {
      return 0;
  }else {
      return parsedNumber;
  }
}
export const getSantizedSublineItem = (sublineItem) => {
  console.log("getSantizedSublineItem input:", sublineItem);

  try {
    if (Array.isArray(sublineItem)) {
      sublineItem = sublineItem.map(item => 
        String(item).trim().replace(/(\r\n|\n|\r)/gm, "")
      );
    } else if (typeof sublineItem === "string") {
      try {
        // Try parsing as JSON array first
        sublineItem = JSON.parse(sublineItem);
        if (!Array.isArray(sublineItem)) throw new Error();
      } catch {
        // Fallback: Remove outer brackets & split manually
        sublineItem = sublineItem
          .replace(/^\[|\]$/g, "") // Remove surrounding brackets
          .split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/) // Split, but keep commas inside quotes
          .map(item => item.trim().replace(/^["']|["']$/g, ""));
      }
    } else {
      throw new Error("Invalid input format");
    }

    // Final cleanup & filtering
    sublineItem = sublineItem.filter(e => e.trim() !== "");

    console.log("getSantizedSublineItem output:", sublineItem);
    return sublineItem;
  } catch (error) {
    console.error("Error in getSantizedSublineItem:", error);
    return [];
  }
};

export const calculateFinanceAmount = (percentage, total, months) => {
  const monthlyRate = (percentage / 100) / 12;
  const factor = Math.pow(1 + monthlyRate, months);
  let monthlyPayment = (total * monthlyRate * factor) / (factor - 1);
  const totalRepayment = monthlyPayment * months;
  let totalInterestPaid = totalRepayment - total;
  monthlyPayment = monthlyPayment.toFixed(2);
  return !isNaN(monthlyPayment)?monthlyPayment:0;
};

export const subscribeToProgress = async (doc_id) => {
  console.log("subscribeToProgress function called.");

  return new Promise((resolve, reject) => {
      consoleLog('Subscribing for onProgressUpdate at ' + getDateTimeV2());
      const subscription = API.graphql(
          graphqlOperation(onProgressUpdate, { doc_id })
      ).subscribe({
          next: async ({ value }) => {
              consoleLog('onProgressUpdate notification received at ' + getDateTimeV2());
              console.log('subscribeToProgress Progress update:', value.data.onProgressUpdate);
              const fileUrl = value.data.onProgressUpdate.details;

              console.log('Fetching File url at ' + getDateTimeV2(), fileUrl);
              try {
                  const response = await fetch(fileUrl);
                  console.log('File url response received at ' + getDateTimeV2());

                  if (!response.ok) {
                      throw new Error("Failed to fetch JSON from S3");
                  }

                  const contentType = response.headers.get("Content-Type");
                  if (!contentType || !contentType.includes("application/json")) {
                      throw new Error("The fetched file is not JSON");
                  }

                  console.log('Getting response text at ' + getDateTimeV2());
                  const rawResponse = await response.text();
                  console.log('Response text received at ' + getDateTimeV2());

                  console.log("Raw Response Body:", rawResponse);

                  const jsonData = JSON.parse(rawResponse);
                  consoleLog("jsonData ===>",jsonData);
                  resolve(jsonData);
              } catch (error) {
                  console.error("Error fetching JSON from S3:", error);
                  reject(error);
              } finally {
                  subscription.unsubscribe();
              }
          },
          error: (error) => {
              console.error(error);
              reject(error); // Reject the promise on error
          },
      });
  });
};

const pollUntilFileExists = (url, timeout = 30000, interval = 1000) => {
  return new Promise((resolve) => {
    const start = Date.now();

    const check = async () => {
      try {
        const response = await fetch(url);
        console.log('File url response received at ' + getDateTimeV2());
        
        if (!response.ok) {
          throw new Error("Failed to fetch JSON from S3");
        }
        
        const contentType = response.headers.get("Content-Type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("The fetched file is not JSON");
        }

        console.log('Getting response text at ' + getDateTimeV2());
        const rawResponse = await response.text();
        console.log('Response text received at ' + getDateTimeV2());
        console.log("Raw Response Body:", rawResponse);

        const jsonData = JSON.parse(rawResponse);
        consoleLog("jsonData ===>",jsonData);
        return resolve(jsonData);
      } catch (_) {
        // ignore errors, will retry
      }

      if (Date.now() - start >= timeout) {
        return resolve(false);
      }

      setTimeout(check, interval);
    };

    check();
  });
};

const pollUntilEditFileExists = (docID, timeout = 15000, interval = 1000, version = null) => {
  // SECURITY: this previously used an AWS.S3 client built from
  // GATSBY_S_THREE_ACCESS_KEY_ID / GATSBY_S_THREE_SECRET_ACCESS_KEY. Gatsby
  // inlines every GATSBY_* variable into the public client bundle, so those
  // IAM credentials shipped to every browser. They were also unnecessary: the
  // exact object name is already known here (`version` is generated
  // client-side and passed to the lambda), so the listObjectsV2 call was only
  // ever matching the single file we had just named.
  const fileName = version
    ? `result_${docID}_version_${version}.json`
    : `result_${docID}.json`;

  // Built from bucket + region + download path, mirroring the URL the old code
  // constructed after listing. Deliberately NOT using GATSBY_S3_DOC_URL: that
  // variable disagrees with GATSBY_S3_DOWNLOAD_PATH on this branch.
  const base = `https://${process.env.GATSBY_S_THREE_BUCKET}.s3.${process.env.GATSBY_S_THREE_REGION}.amazonaws.com/${process.env.GATSBY_S3_DOWNLOAD_PATH}/results`;
  const fileURL = `${base}/${fileName}?t=${Date.now()}`;

  console.log(`[POLL START] docID=${docID}, version=${version}, timeout=${timeout}ms, url=${fileURL}`);

  return pollUntilFileExists(fileURL, timeout, interval);
};

export const apiCallWithSubscription = async (variables, queryName) => {
  try {
      const queryMap = {
          createDocWithTemplate,
          getDocumentEstimateData,
          getDocumentWorkOrderData,
          applyWorkOrderTemplate
      };
      const query = queryMap[queryName];
      //making version of result json 
      var version = Date.now();
      if(queryName === "applyWorkOrderTemplate"){
        // apply work order  will have separate versioning as it can be called multiple times for same doc_id, so appending version to doc_type_id
        variables.doc_type_id= parseInt(variables.doc_type_id);
        variables.json_file_version= version;
      }
      if (!query) return 0;
      console.log(queryName + ' lambda called at ' + getDateTimeV2());
      const apiResponse = await API.graphql({ query, variables });
      console.log(queryName + ' lambda response received at ' + getDateTimeV2());
      if (queryName === "createDocWithTemplate") {
        // Use known doc_id and construct S3 URL
        const docId = variables.doc_id; // Adjust based on actual variable
        const fileURL = `${process.env.GATSBY_S3_DOC_URL}/result_${docId}.json?t=${Date.now()}`;

        console.log("📦 Constructed S3 URL:", fileURL);

        const docData = await pollUntilFileExists(fileURL, 120000, 1000);

        if (docData) {
          console.log("✅ Data is available:", docData);
          return docData;
        } else {
          console.warn("❌ Data not found againt file within timeout:", fileURL);
          return null;
        }
      } else if (queryName === "getDocumentEstimateData" || queryName === "getDocumentWorkOrderData" || queryName === "applyWorkOrderTemplate") {
         const docId = variables.doc_id;  
         var docData;
        if(queryName === "applyWorkOrderTemplate"){
          // pulling axact file for apply work order template as it can be called multiple times for same doc_id, so using version to pull the file
            console.log("Pulling file for docId:", docId, "and version:", version);
            docData = await pollUntilEditFileExists(docId, 120000, 1000,version);
          }else{
             docData = await pollUntilEditFileExists(docId, 120000, 1000);
          }

          if (docData) {
            console.log("✅ Data is available:", docData);
            return docData;
          } else {
            console.warn("❌ Data not found againt file within timeout:");
            return null;
          }
      } else {
        console.log('Subscribing to ' + queryName + ' progress at ' + getDateTimeV2());
        const subscriptionData = await subscribeToProgress(variables.doc_id);
        console.log('Subscribing to ' + queryName + ' progress subscription response received at ' + getDateTimeV2());
        return subscriptionData;
      }
      
  } catch (error) {
      console.error("API Call with Subscription Error:", error);
      throw error;
  }
};

export const getDateTimeV2 = () => {
  var d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2)
      month = '0' + month;
  if (day.length < 2)
      day = '0' + day;

  let date = [year, month, day].join('-');

  let hour = d.getHours();
  let minutes = d.getMinutes();
  let seconds = d.getSeconds();
  let milliseconds = d.getMilliseconds();

  if (hour.length < 2)
      hour = '0' + hour;
  if (minutes.length < 2)
      minutes = '0' + minutes;
  if (seconds.length < 2)
    seconds = '0' + seconds;
  if (milliseconds.length < 2)
    milliseconds = '0' + milliseconds;

  let time = [hour, minutes, seconds, milliseconds].join(':');

  return date+' '+time; 
}

export const safeParse = (str) => {
  try {
    return typeof str === 'string' ? JSON.parse(str) : str;
  } catch {
    return str;
  }
};

export function cleanSubLineItem(sub_line_item_copy) {
  if (typeof sub_line_item_copy === "string") {
      let val = sub_line_item_copy;
      try {
          // Keep parsing until result is no longer a string
          while (typeof val === "string") {
              val = JSON.parse(val);
          }
      } catch {
          return sub_line_item_copy; // fallback if parsing fails
      }
      return val; // should be array like ["..."]
  }
  return sub_line_item_copy;
}


export function extractQuantitiesByAlgo(data, targetAlgo = false) {
  let quantities_data;
  
  try {
    quantities_data = JSON.parse(data);
  } catch (e) {
    console.error('Invalid JSON data');
    return { quantity: 0, unit: 'N/A' };
  }

  // Handle both cases: array directly or object with .quantities
  const structures = Array.isArray(quantities_data)
    ? quantities_data
    : (quantities_data.quantities || []);
  
  // Validate
  if (!Array.isArray(structures)) {
    console.error('Invalid data format: Expected an array');
    return { quantity: 0, unit: 'N/A' };
  }
  
  try {
    // Iterate through each structure
    for (const structure of structures) {
      if (!structure || !structure.scopes || !Array.isArray(structure.scopes)) continue;
  
      // Iterate through each scope
      for (const scope of structure.scopes) {
        if (!scope || !scope.quantities || typeof scope.quantities !== 'object') continue;
  
        // Check each quantity
        for (const value of Object.values(scope.quantities)) {
          if (!value || typeof value !== 'object') continue;
          
          // If algo matches or no specific algo requested
          if (!targetAlgo || value.algo === targetAlgo) {
            return {
              quantity: typeof value.quantity === 'number' ? value.quantity : 0,
              unit: value.unit || 'N/A'
            };
          }
        }
      }
    }
  } catch (error) {
    console.error('Error processing data:', error);
  }

  // Return default if nothing found
  return { quantity: 0, unit: 'N/A' };
}
